import reduce from 'lodash/reduce';

const row1 = [
  { name: 'Tab', character: 'tab' },
  {
    name: 'q',
    character: 'q',
    alt: 'Q',
    special: '1'
  },
  {
    name: 'w',
    character: 'w',
    alt: 'W',
    special: '2'
  },
  {
    name: 'e',
    character: 'e',
    alt: 'E',
    special: '3'
  },
  {
    name: 'r',
    character: 'r',
    alt: 'R',
    special: '4'
  },
  {
    name: 't',
    character: 't',
    alt: 'T',
    special: '5'
  },
  {
    name: 'y',
    character: 'y',
    alt: 'Y',
    special: '6'
  },
  {
    name: 'u',
    character: 'u',
    alt: 'U',
    special: '7'
  },
  {
    name: 'i',
    character: 'i',
    alt: 'I',
    special: '8'
  },
  {
    name: 'o',
    character: 'o',
    alt: 'O',
    special: '9'
  },
  {
    name: 'p',
    character: 'p',
    alt: 'P',
    special: '0'
  },
  {
    name: 'backspace',
    character: 'backspace',
    special: 'backspace'
  }
];

const row2 = [
  { name: 'CapLock', character: 'CapLock' },
  {
    name: 'a',
    character: 'a',
    alt: 'A',
    special: '!'
  },
  {
    name: 's',
    character: 's',
    alt: 'S',
    special: '@'
  },
  {
    name: 'd',
    character: 'd',
    alt: 'D',
    special: '#'
  },
  {
    name: 'f',
    character: 'f',
    alt: 'F',
    hold: 'left',
    special: '$'
  },
  {
    name: 'g',
    character: 'g',
    alt: 'G',
    special: '%'
  },
  {
    name: 'h',
    character: 'h',
    alt: 'H',
    special: '^'
  },
  {
    name: 'j',
    character: 'j',
    alt: 'J',
    hold: 'right',
    special: '&'
  },
  {
    name: 'k',
    character: 'k',
    alt: 'K',
    special: '*'
  },
  {
    name: 'l',
    character: 'l',
    alt: 'L',
    special: '('
  },
  {
    name: 'semicolon',
    character: ';',
    alt: ':',
    special: ')'
  },
  {
    name: 'enter',
    character: 'enter',
    special: '"'
  }
];

const row3 = [
  {
    name: 'shift1',
    character: 'shift1',
    hold: 'left',
    shift: true
  },
  {
    name: 'z',
    character: 'z',
    alt: 'Z',
    special: '-'
  },
  {
    name: 'x',
    character: 'x',
    alt: 'X',
    special: '+'
  },
  {
    name: 'c',
    character: 'c',
    alt: 'C',
    special: '='
  },
  {
    name: 'v',
    character: 'v',
    alt: 'V',
    special: '/'
  },
  {
    name: 'b',
    character: 'b',
    alt: 'B',
    special: '<'
  },
  {
    name: 'n',
    character: 'n',
    alt: 'N',
    special: '>'
  },
  {
    name: 'm',
    character: 'm',
    alt: 'M',
    special: ','
  },
  {
    name: 'comma',
    character: ',',
    alt: '!',
    special: '.'
  },
  {
    name: 'period',
    character: '.',
    alt: '?',
    special: "'"
  },
  {
    name: 'shift2',
    character: 'shift2',
    hold: 'right',
    shift: true
  }
];

const row4 = [
  { character: '123', name: 'SpecialNumber', special: 'abc' },
  { character: ' ', name: 'space', special: ' ' }
];

export const keys = {
  row1,
  row2,
  row3,
  row4
};

export const keyLayout = [
  { name: 'row1', keys: row1 },
  { name: 'row2', keys: row2 },
  { name: 'row3', keys: row3 },
  { name: 'row4', keys: row4 }
];

export const holdKeys = ['f', 'j'];

const createMap = () => {
  const map = {};

  return {
    set(key, value) {
      map[key] = value;
    },

    get(key) {
      return map[key];
    }
  };
};

export const characterMap = reduce(
  keys,
  (mapAcc, chars, rowName) => {
    chars.forEach(char => mapAcc.set(char, rowName));

    return mapAcc;
  },
  createMap()
);
